'use client';

import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import { EpTextarea } from '../../../EpInput';
import style from '../../Forms/IncidentNotification/FormIncidentNotification.module.scss';
import { EpErrorMessage } from '../EpErrorMessage';

interface IEpStepTextAreaProps {
  disabled?: boolean;
  errorMessage?: string;
  maxLength?: number;
  registerId: string;
  visible?: boolean;
  required?: boolean;
  translations?: string[];
}

export const EpStepTextArea = ({
  disabled = false,
  maxLength,
  registerId,
  visible = true,
  required = true,
  translations,
  errorMessage = '* Required Fied',
}: IEpStepTextAreaProps) => {
  const { register, getValues, formState: { errors } } = useFormContext();
  const [textAreaLenght, setTextAreaLenght] = useState(
    getValues(registerId) || '',
  );

  if (!visible) null;

  return (
    <>
      <EpTextarea
        inputName={registerId}
        inputId={registerId}
        inputSize={'md'}
        inputIsFullWidth={true}
        inputIsDisabled={disabled}
        inputWithError={!!errors[registerId]}
        inputMaxLength={maxLength ? maxLength : undefined}
        {...register(`${registerId}` as const, {
          required: {
            value: required,
            message: t(translations, errorMessage),
          },
          onChange: (e) => setTextAreaLenght(e.target.value),
          disabled,
        })}
      ></EpTextarea>

      {maxLength && (
        <span className={style['card__txt']}>
          {t(translations, 'Number of remaining characters:')}{' '}
          {maxLength - textAreaLenght.length}
        </span>
      )}
      <EpErrorMessage inputName={registerId} />
    </>
  );
};
